<template lang="pug">
div(class="m-card-effectiveness-accordion-question")
    m-card(v-bind="$attrs" v-if="!isCollapsible(item)" v-on="$listeners" :hovered="!isCollapsible(item)" :ripple="!isCollapsible(item)" :elevation="false")
        template(#title="")
            v-layout( class="py-1")
                v-flex(xs12 px-0 py-0)
                    e-typography-body-small(tabindex="0")
                        e-typography-links-small(class="m-card-effectiveness-accordion-question__item")
                            component(:is="item.iconComponnent" v-if="item.iconComponnent" @click.native.stop="openIconInfoDialog" class="m-card-effectiveness-accordion-question__icon")
                            | {{item.title}}
    m-accordion-primary(v-else class="m-card-effectiveness-accordion-question__sub-accordion")
        m-accordion-content()
            template(#header="")
                v-flex( class="px-0 pt-2 pb-2 pl-2" xs12 class="m-card-effectiveness-accordion-question__sub-accordion__container")
                    e-typography-body-small(class="m-card-effectiveness-accordion-question__sub-accordion__item" @click.native.stop="$emit('click:option-question', {item:item, index:index})")
                        component(:is="item.iconComponnent"
                            @click.native.stop="openIconInfoDialog"
                            v-if="item.iconComponnent"
                            class="m-card-effectiveness-accordion-question__sub-accordion__icon")
                        | {{item.title}}
            m-list-effectiveness-option(m-card-effectiveness-accordion-question__sub-accordion
                :answers="answers"
                :items="getOptionsChildren(item)"
                :main-section-key="sectionKey"
                :section-key="index"
                @click:option-question="$emit('click:option-question', $event)"
                class="m-card-effectiveness-accordion-question__sub-accordion__list")
</template>

<script>

    import MCard from "@modules/cards/m-card";
    import MAccordionPrimary from "@modules/accordions/types/m-accordion-primary";
    import MAccordionContent from "@modules/accordions/includes/_m-accordion-content";
    import MListEffectivenessOption from '@modules/lists/concrete/m-list-effectiveness-option';
    import {questions} from "@constants/common";
    import statusIconDialog from "@mixins/additional/_statusIconDialog";

    export default {
        name: "m-card-effectiveness-accordion-question",
        mixins: [statusIconDialog],
        components: {
            MListEffectivenessOption,
            MAccordionContent,
            MAccordionPrimary,
            MCard
        },
        props: {
            item: {
                type: Object
            },
            answers: {
                type: Array
            },
            index: {
                type: Number
            },
            sectionKey: {
                type: Number
            }
        },
        methods: {
            getOptionsChildren(question) {

                if (typeof question.children === "undefined") {
                    return [];
                }

                if (typeof question.children[0] === "undefined") {
                    return [];
                }

                if (typeof question.children[0].children === "undefined") {
                    return [];
                }

                return question.children[0].children;
            },
            isCollapsible(question) {
                if (typeof question.children === "undefined" || !question.children[0]) {
                    return false;
                }

                if (typeof question.children[0].type === "undefined") {
                    return false;
                }

                if (question.children[0].type !== questions.types.options) {
                    return false;
                }

                // TODO: Check if options' section length should be less then 2 or if options' sections' children should be less than 2.
                // if (!question.children[0].children || question.children[0].children.length < 2) {
                //     return false;
                // }

                return true;
            }
        },
    }
</script>

<style lang="scss">
    .m-card-effectiveness-accordion-question {
        &__sub-accordion {
            &__list > .flex {
                padding-top: 0 !important;
            }
            .v-expansion-panel {
                &__container {
                    box-shadow: none !important;
                }
            }
            &__item.e-typography-body-small {
                padding-left: 0.3rem!important;
            }
            &__item {
                position: relative;
                display: inline-block;
                cursor: pointer;
                &:hover{
                    color: var(--v-primary-base);
                }
            }
        }
    }
</style>


<style scoped lang="scss">
    .m-card-effectiveness-accordion-question {
        /deep/ .v-list__tile {
            padding-left: 0;
            padding-right: 0;
        }

        &__item {
            position: relative;
            display: inline-block;
            font-weight: normal;

            @include media(md) {
                margin-left: 0px;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 95%;
                max-width: 85vw;
            }
        }

        &__m-card {
            padding-left: 0 !important;
        }

        &__icon {
            margin-right: .5rem;
        }

        /deep/ .v-expansion-panel {
            &__container {
                height: auto;
                padding: 1rem 0 1rem 0 !important;
                border-top: none !important;
                border-bottom: 1px solid var(--v-secondary-base);

                &:focus {
                    border-bottom: 2px solid var(--v-primary-base) !important;
                }
            }

            &__body {
                padding-top: 1rem !important;
            }
        }

        &__sub-accordion {
            .v-expansion-panel {
                &__container {
                    padding: 0;
                    margin-bottom: 0 !important;
                }
            }

            /deep/ > .v-list__tile:hover {
                background-color: white !important;
            }

            &__container {
                padding: 0 !important;
                margin: 0 !important;
            }

            &__icon {
                margin-right: .5rem;

                @include media(md) {
                    position: unset;
                    left: 0px;
                    padding-right: 10px;
                }
            }

            &__list {
                margin-top: 0 !important;
                margin-bottom: 0 !important;
            }


            /deep/ .v-expansion-panel {
                &__container {
                    padding: 0 !important;
                    margin: 0;
                    border-bottom: none !important;
                    border-top: none !important;
                    background-color: transparent;
                }

                &__body {
                    padding-top: 0rem !important;

                    /deep/ hr {
                        display: none !important;
                    }
                }
            }
        }

        .e-typography-body-small {
            outline: none;
            padding: .5rem;
            padding-left: 1rem;

            @include media(md) {
                display: flex;
            }

            &:focus {
                border-bottom: 2px solid var(--v-primary-base);
            }
        }
    }
</style>
